import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=fcbaebe0&"
import script from "./uploadFile.vue?vue&type=script&lang=ts&"
export * from "./uploadFile.vue?vue&type=script&lang=ts&"
import style0 from "./uploadFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports